/*
 * @Descripttion: 
 * @version: 
 * @Author: sueRimn
 * @Date: 2020-07-10 16:27:14
 * @LastEditors: mrh
 * @LastEditTime: 2022-10-22 15:15:49
 */
import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
// 路由meta参数备注 keepAlive是否缓存界面、backdrop背景是否为灰色、isBack是否为上一页返回回来、hiddenHeader是否隐藏头部、iconBackHidden是否隐藏头部返回键
const router = new Router({
  // mode:'history',
  routes: [
    //路由懒加载
    {
      path: "/buyAgreement",
      component: (resolve) => require(["./view/personal/buyAgreement.vue"], resolve),
      meta: { title: "", keepAlive: false, hiddenHeader: true },
    },
    {
      name: "auditPublisher",
      path: "/auditPublisher",
      component: (resolve) => require(["./view/publisher/auditPublisher.vue"], resolve),
      meta: { title: "", keepAlive: false },
    },
    {
      name: "perfect",
      path: "/perfect",
      component: (resolve) => require(["./view/publisher/perfect.vue"], resolve),
      meta: { title: "完善资料", keepAlive: false },
    },
    {
      name: "publisher",
      path: "/publisher",
      component: (resolve) => require(["./view/publisher/publisher.vue"], resolve),
      meta: { title: "成为发布商", keepAlive: false },
    },
    {
      name: "applyPublishers",
      path: "/applyPublishers",
      component: (resolve) => require(["./view/publisher/applyPublishers.vue"], resolve),
      meta: { title: "发布商注册", keepAlive: false, hiddenHeader: true },
    },
    {
      name: "purchaseOrder",
      path: "/purchaseOrder",
      component: (resolve) => require(["./view/seller/purchaseOrder.vue"], resolve),
      meta: { title: "商品采购单", keepAlive: false, hiddenHeader: true },
    },
    {
      name: "businessInformation",
      path: "/businessInformation",
      component: (resolve) => require(["./view/information/businessInformation.vue"], resolve),
      meta: { title: "", keepAlive: false },
    },
    {
      name: "registerAgreement",
      path: "/registerAgreement",
      component: (resolve) => require(["./view/aboutCampus/registerAgreement.vue"], resolve),
      meta: { title: "资质与协议", keepAlive: true },
    },
    {
      name: "details",
      path: "/details",
      component: (resolve) => require(["./view/aboutCampus/details.vue"], resolve),
      meta: { title: "营业执照", keepAlive: true },
    },
    {
      name: "agreementTest",
      path: "/agreementTest",
      component: (resolve) => require(["./view/aboutCampus/agreementTest.vue"], resolve),
      meta: { title: "", keepAlive: true },
    },
    {
      path: "/video",
      component: (resolve) => require(["./view/video/videoup.vue"], resolve),
      meta: { title: "视频", keepAlive: true },
    },
    {
      path: "/finance",
      component: (resolve) => require(["./view/finance/finance.vue"], resolve),
      meta: { title: "提现", keepAlive: true, backdrop: true },
    },
    {
      name: "withdrawDeposit",
      path: "/withdrawDeposit",
      component: (resolve) => require(["./view/finance/withdrawDeposit.vue"], resolve),
      meta: { title: "提现", keepAlive: true, backdrop: true, isBack: false },
    },
    {
      name: "withdrawSuccess",
      path: "/withdrawSuccess",
      component: (resolve) => require(["./view/finance/withdrawSuccess.vue"], resolve),
      meta: { title: "提现", keepAlive: false, backdrop: true },
    },
    {
      name: "withdrawDetail",
      path: "/withdrawDetail",
      component: (resolve) => require(["./view/finance/withdrawDetail.vue"], resolve),
      meta: { title: "提现详情", keepAlive: false, backdrop: true },
    },
    {
      name: "extractCode",
      path: "/extractCode",
      component: (resolve) => require(["./view/finance/extractCode.vue"], resolve),
      meta: { title: "提现", keepAlive: false, backdrop: true },
    },
    {
      name: "successfully",
      path: "/successfully",
      component: (resolve) => require(["./view/finance/successfully.vue"], resolve),
      meta: { title: "绑定银行卡", keepAlive: false },
    },
    {
      path: "/bankCard",
      component: (resolve) => require(["./view/finance/bankCard.vue"], resolve),
      meta: { title: "我的银行卡", keepAlive: false },
    },
    {
      name: "register",
      path: "/register",
      component: (resolve) => require(["./view/finance/register.vue"], resolve),
      meta: { title: "绑定银行卡", keepAlive: true, backdrop: true, isBack: false },
    },
    {
      name: "noteCheck",
      path: "/noteCheck",
      component: (resolve) => require(["./view/finance/noteCheck.vue"], resolve),
      meta: { title: "绑定银行卡", keepAlive: false, backdrop: true },
    },
    {
      path: "/search",
      component: (resolve) => require(["./view/searchs/search.vue"], resolve),
      meta: { title: "我要推荐", keepAlive: true, hiddenHeader: true },
    },
    {
      path: "/shops",
      component: (resolve) => require(["./view/shops/shop.vue"], resolve),
      meta: { title: "我的店铺", keepAlive: true, hiddenHeader: true },
    },
    {
      path: "/personal",
      component: (resolve) => require(["./view/personal/personal.vue"], resolve),
      meta: { title: "我的", keepAlive: true, backdrop: true },
    },
    {
      path: "/order",
      component: (resolve) => require(["./view/personal/order.vue"], resolve),
      meta: { title: "店铺订单", keepAlive: true, backdrop: true, isBack: false },
    },
    {
      path: "/orderDetails",
      component: (resolve) => require(["./view/personal/orderDetails.vue"], resolve),
      meta: { title: "订单详情", keepAlive: true, backdrop: true, isBack: false },
    },
    {
      path: "/orderSearch",
      component: (resolve) => require(["./view/personal/orderSearch.vue"], resolve),
      meta: { title: "店铺订单", keepAlive: true, backdrop: true, isBack: false },
    },
    {
      path: "/strategy",
      component: (resolve) => require(["./view/personal/strategy.vue"], resolve),
      meta: { title: "社区店长攻略", keepAlive: false },
    },
    {
      path: "/schoolAgreement",
      component: (resolve) => require(["./view/personal/schoolAgreement.vue"], resolve),
      meta: { title: "", keepAlive: false, hiddenHeader: true },
    },
    {
      path: "/beSettled",
      component: (resolve) => require(["./view/personal/beSettled.vue"], resolve),
      meta: { title: "未到账", keepAlive: true, backdrop: true, isBack: false },
    },
    {
      path: "/beSettledRule",
      component: (resolve) => require(["./view/personal/beSettledRule.vue"], resolve),
      meta: { title: "规则说明", keepAlive: false },
    },
    {
      path: "/logistics",
      component: (resolve) => require(["./view/personal/logistics.vue"], resolve),
      meta: { title: "查看物流", keepAlive: false },
    },
    {
      path: "/userOrder",
      component: (resolve) => require(["./view/personal/userOrder.vue"], resolve),
      meta: { title: "扫码提货", keepAlive: false, backdrop: true },
    },
    {
      path: "/searchGoods",
      component: (resolve) => require(["./view/searchs/searchGoods.vue"], resolve),
      meta: { title: "搜索", keepAlive: true, isBack: false, hiddenHeader: true },
    },
    {
      path: "/notice",
      component: (resolve) => require(["./view/shops/notice.vue"], resolve),
      meta: { title: "预告专区", keepAlive: false },
    },
    {
      name: "set",
      path: "/set",
      component: (resolve) => require(["./view/setting/set.vue"], resolve),
      meta: { title: "个人信息", keepAlive: false, backdrop: true },
    },
    {
      path: "/applyIndex",
      component: (resolve) => require(["./view/apply/applyIndex.vue"], resolve),
      meta: { title: "成为店长", keepAlive: false },
    },
    {
      name: "applyRegister",
      path: "/applyRegister",
      component: (resolve) => require(["./view/apply/applyRegister.vue"], resolve),
      meta: { title: "成为店长", keepAlive: true },
    },
    {
      path: "/applyCommunity",
      component: (resolve) => require(["./view/apply/applyCommunity.vue"], resolve),
      meta: { title: "选择社区", keepAlive: true, backdrop: true },
    },
    {
      name: "applySuccess",
      path: "/applySuccess",
      component: (resolve) => require(["./view/apply/applySuccess.vue"], resolve),
      meta: { title: "提交成功", keepAlive: false },
    },
    {
      path: "/goodsMsg",
      component: (resolve) => require(["./view/shops/goodsMsg.vue"], resolve),
      meta: { title: "商品详情", keepAlive: false },
    },
    {
      path: "/myShareGoods",
      component: (resolve) => require(["./view/share/myShareGoods.vue"], resolve),
      meta: { title: "分享商品", keepAlive: false, backdrop: true },
    },
    {
      path: "/address",
      component: (resolve) => require(["./view/share/address.vue"], resolve),
      meta: { title: "收货地址", keepAlive: false },
    },
    {
      path: "/share",
      component: (resolve) => require(["./components/share/share.vue"], resolve),
      meta: { title: "分享商品", keepAlive: false },
    },
    {
      path: "/openCmt",
      component: (resolve) => require(["./view/openCommunity/openCmt.vue"], resolve),
      meta: { title: "开通社区", keepAlive: true },
    },
    {
      path: "/openShopCmt",
      component: (resolve) => require(["./view/openCommunity/openShopCmt.vue"], resolve),
      meta: { title: "开通社区", keepAlive: true },
    },
    {
      path: "/map",
      component: (resolve) => require(["./view/openCommunity/map.vue"], resolve),
      meta: { title: "选择地址", keepAlive: false },
    },
    {
      path: "/manage",
      component: (resolve) => require(["./view/personal/manage.vue"], resolve),
      meta: { title: "副店长管理", keepAlive: false },
    },
    {
      path: "/success",
      component: (resolve) => require(["./view/openCommunity/success.vue"], resolve),
      meta: { title: "提交成功", keepAlive: false },
    },
    {
      path: "/recruitPartner",
      component: (resolve) => require(["./view/invite/recruitPartner.vue"], resolve),
      meta: { title: "招募城市合伙人", keepAlive: false },
    },
    {
      path: "/appDownload",
      component: (resolve) => require(["./view/invite/appDownload.vue"], resolve),
      meta: { title: "如何下载app", keepAlive: false },
    },
    {
      path: "/configH5Video",
      component: (resolve) => require(["./view/invite/configH5Video.vue"], resolve),
      meta: { title: "发布视频点赞PK赢5000元大奖！", keepAlive: false },
    },
    {
      path: "/inviteShopowner",
      component: (resolve) => require(["./view/invite/inviteShopowner.vue"], resolve),
      meta: { title: "邀请店长", keepAlive: false },
    },
    {
      path: "/afterSaleMsg",
      component: (resolve) => require(["./view/personal/afterSaleMsg.vue"], resolve),
      meta: { title: "售后", keepAlive: false, backdrop: true },
    },
    {
      path: "/setState",
      component: (resolve) => require(["./view/personal/setState.vue"], resolve),
      meta: { title: "设置", keepAlive: false },
    },
    {
      name: "deliverySet",
      path: "/deliverySet",
      component: (resolve) => require(["./view/personal/deliverySet.vue"], resolve),
      meta: { title: "配送设置", keepAlive: false, backdrop: true },
    },
    {
      name: "leaderboard",
      path: "/leaderboard",
      component: (resolve) => require(["./view/leaderboard/leaderboard.vue"], resolve),
      meta: { title: "排行榜", keepAlive: true, iconBackHidden: false },
    },
    {
      name: "shopLeaderboard",
      path: "/shopLeaderboard",
      component: (resolve) => require(["./view/leaderboard/shopLeaderboard.vue"], resolve),
      meta: { title: "排行榜", keepAlive: true, iconBackHidden: true },
    },
    {
      name: "awardRecord",
      path: "/awardRecord",
      component: (resolve) => require(["./view/leaderboard/awardRecord.vue"], resolve),
      meta: { title: "获奖记录", keepAlive: false, backdrop: true },
    },
    {
      name: "shopAwardList",
      path: "/shopAwardList",
      component: (resolve) => require(["./view/leaderboard/shopAwardList.vue"], resolve),
      meta: { title: "获奖名单", keepAlive: false, backdrop: true },
    },
    {
      name: "awardList",
      path: "/awardList",
      component: (resolve) => require(["./view/leaderboard/awardList.vue"], resolve),
      meta: { title: "获奖名单", keepAlive: false },
    },
    {
      path: "/invitationDetails",
      component: (resolve) => require(["./view/leaderboard/invitationDetails.vue"], resolve),
      meta: { title: "邀请明细", keepAlive: false },
    },
    {
      path: "/agreement",
      component: (resolve) => require(["./view/finance/agreement.vue"], resolve),
      meta: { title: "平安银行电子商务支付结算服务协议", keepAlive: false, hiddenHeader: true },
    },
    {
      path: "/shopAgreement",
      component: (resolve) => require(["./view/shopAgreement/shopAgreement.vue"], resolve),
      meta: { title: "店长用户协议", keepAlive: false },
    },
    {
      path: "/vrPlay",
      component: (resolve) => require(["./view/vrPlay/vrPlay.vue"], resolve),
      meta: { title: "vr", keepAlive: false },
    },
    {
      path: "/messageShare",
      component: (resolve) => require(["./view/bkl/messageShare.vue"], resolve),
      meta: { title: "第三方信息数据共享", keepAlive: false },
    },
    {
      path: "/messageList",
      component: (resolve) => require(["./view/bkl/messageList.vue"], resolve),
      meta: { title: "个人信息收集清单", keepAlive: false },
    },

    // 行家相关的路由
    {
      name: "e_withdrawDeposit",
      path: "/e_withdrawDeposit",
      component: (resolve) => require(["./view/expert/e_withdrawDeposit.vue"], resolve),
      meta: {
        title: "提现",
        keepAlive: true,
        backdrop: true,
        isBack: false
      },
    }, {
      name: "e_dataDetails",
      path: "/e_dataDetails",
      component: (resolve) => require(["./view/expert/e_dataDetails.vue"], resolve),
      meta: {
        title: "数据详情",
        backdrop: true,
        isBack: true
      },
    },{
      name: "e_withdrawSuccess",
      path: "/e_withdrawSuccess",
      component: (resolve) => require(["./view/expert/e_withdrawSuccess.vue"], resolve),
      meta: {
        title: "提现",
        keepAlive: false,
        backdrop: true
      },
    }, {
      name: "e_withdrawDetail",
      path: "/e_withdrawDetail",
      component: (resolve) => require(["./view/expert/e_withdrawDetail.vue"], resolve),
      meta: {
        title: "提现详情",
        keepAlive: false,
        backdrop: true
      },
    }, {
      name: "e_extractCode",
      path: "/e_extractCode",
      component: (resolve) => require(["./view/expert/e_extractCode.vue"], resolve),
      meta: {
        title: "提现",
        keepAlive: false,
        backdrop: true
      },
    }, {
      name: "e_successfully",
      path: "/e_successfully",
      component: (resolve) => require(["./view/expert/e_successfully.vue"], resolve),
      meta: {
        title: "绑定银行卡",
        keepAlive: false
      },
    }, {
      path: "/e_bankCard",
      component: (resolve) => require(["./view/expert/e_bankCard.vue"], resolve),
      meta: {
        title: "我的银行卡",
        keepAlive: false
      },
    }, {
      name: "e_register",
      path: "/e_register",
      component: (resolve) => require(["./view/expert/e_register.vue"], resolve),
      meta: {
        title: "绑定银行卡",
        keepAlive: true,
        backdrop: true,
        isBack: false
      },
    }, {
      name: "e_noteCheck",
      path: "/e_noteCheck",
      component: (resolve) => require(["./view/expert/e_noteCheck.vue"], resolve),
      meta: {
        title: "绑定银行卡",
        keepAlive: true,
        backdrop: true
      },
    },
    {
      path: "/e_agreement",
      component: (resolve) => require(["./view/expert/e_agreement.vue"], resolve),
      meta: {
        title: "平安银行电子商务支付结算服务协议",
        keepAlive: false,
        hiddenHeader: true
      },
    },
    {
      path: "/getRuleContent",
      component: (resolve) => require(["./view/expert/getRuleContent.vue"], resolve),
      meta: {
        title: "",
        keepAlive: false,
        hiddenHeader: true
      },
    },
    {
      path: "/advertisingStats",
      component: (resolve) => require(["./view/expert/advertisingStats/index.vue"], resolve),
      meta: {
        title: "投放广告",
        keepAlive: false,
        hiddenHeader: true
      },
    },
    {
      name:'writeOffIndex',
      path: "/writeOffIndex",
      component: (resolve) => require(["./view/expert/e_writeOff/writeOffIndex.vue"], resolve),
      meta: {
        title: "申请注销账号",
        keepAlive: false,
        // hiddenHeader: false
      },
    },
    {
      name:'logout',
      path: "/logout",
      component: (resolve) => require(["./view/expert/e_writeOff/logout.vue"], resolve),
      meta: {
        title: "申请注销账号",
        keepAlive: false,
        // hiddenHeader: false
      },
    },
    // logoutNext
    {
      name:'logoutNext',
      path: "/logoutNext",
      component: (resolve) => require(["./view/expert/e_writeOff/logoutNext.vue"], resolve),
      meta: {
        title: "安全验证",
        keepAlive: false,
        // hiddenHeader: false
      },
    },
    {
      name:'logoutNotice',
      path: "/logoutNotice",
      component: (resolve) => require(["./view/expert/e_writeOff/logoutNotice.vue"], resolve),
      meta: {
        title: "注销须知",
        keepAlive: false,
        // hiddenHeader: false,
      },
    },
    {
      name:'cancellationNotice',
      path: "/cancellationNotice",
      component: (resolve) => require(["./view/expert/e_writeOff/cancellationNotice.vue"], resolve),
      meta: {
        title: "注销须知",
        keepAlive: false,
        // hiddenHeader: false,
      },
    },
    {
      name:'expertLogout',
      path: "/expertLogout",
      component: (resolve) => require(["./view/expert/e_writeOff/expertLogout.vue"], resolve),
      meta: {
        title: "安全验证",
        keepAlive: false,
        // hiddenHeader: false,
      },
    },
    {
      name:'e_registerAgreement',
      path: "/e_registerAgreement",
      component: (resolve) => require(["./view/expert/e_registerAgreement.vue"], resolve),
      meta: {
        title: "资质与协议",
        keepAlive: true,
        // hiddenHeader: false,
      },
    },
    // 行家用
    {
      name:'e_personalData',
      path: "/e_personalData",
      component: (resolve) => require(["./view/expert/personalData/e_personalData.vue"], resolve),
      meta: {
        title: "个人信息收集清单",
        keepAlive: true,
        // hiddenHeader: false,
      },
    },
    {
      name:'basicInformation',
      path: "/basicInformation",
      component: (resolve) => require(["./view/expert/personalData/basicInformation.vue"], resolve),
      meta: {
        title: "用户基本信息",
        keepAlive: true,
        // hiddenHeader: false,
      },
    },
    {
      name:'identityInformation',
      path: "/identityInformation",
      component: (resolve) => require(["./view/expert/personalData/identityInformation.vue"], resolve),
      meta: {
        title: "用户身份信息",
        keepAlive: true,
        // hiddenHeader: false,
      },
    },
    {
      name:'locationInformation',
      path: "/locationInformation",
      component: (resolve) => require(["./view/expert/personalData/locationInformation.vue"], resolve),
      meta: {
        title: "位置信息",
        keepAlive: true,
        // hiddenHeader: false,
      },
    },
    {
      name:'thirdpartyInformationShare',
      path: "/thirdpartyInformationShare",
      component: (resolve) => require(["./view/expert/personalData/thirdpartyInformationShare.vue"], resolve),
      meta: {
        title: "第三方信息共享清单",
        keepAlive: true,
        // hiddenHeader: false,
      },
    },
    // 卖家用
    {
      name:'SellerPersonalData',
      path: "/SellerPersonalData",
      component: (resolve) => require(["./view/seller/personalData/e_personalData.vue"], resolve),
      meta: {
        title: "个人信息收集清单",
        keepAlive: true,
        // hiddenHeader: false,
      },
    },
    {
      name:'SellerBasicInformation',
      path: "/SellerBasicInformation",
      component: (resolve) => require(["./view/seller/personalData/basicInformation.vue"], resolve),
      meta: {
        title: "用户基本信息",
        keepAlive: true,
        // hiddenHeader: false,
      },
    },
    {
      name:'SellerIdentityInformation',
      path: "/SellerIdentityInformation",
      component: (resolve) => require(["./view/seller/personalData/identityInformation.vue"], resolve),
      meta: {
        title: "用户身份信息",
        keepAlive: true,
        // hiddenHeader: false,
      },
    },
    {
      name:'SellerLocationInformation',
      path: "/SellerLocationInformation",
      component: (resolve) => require(["./view/seller/personalData/locationInformation.vue"], resolve),
      meta: {
        title: "位置信息",
        keepAlive: true,
        // hiddenHeader: false,
      },
    },
    {
      name:'SellerThirdpartyInformationShare',
      path: "/SellerThirdpartyInformationShare",
      component: (resolve) => require(["./view/seller/personalData/thirdpartyInformationShare.vue"], resolve),
      meta: {
        title: "第三方信息共享清单",
        keepAlive: true,
        // hiddenHeader: false,
      },
    },
    {
      name:'sellerRule',
      path: "/sellerRule",
      component: (resolve) => require(["./view/seller/sellerRule.vue"], resolve),
      meta: {
        title: "协议",
        keepAlive: false,
        // hiddenHeader: false,
      },
    },
    {
      name:'circleNote',
      path: "/circleNote",
      component: (resolve) => require(["./view/expert/circleNote.vue"], resolve),
      meta: {
        title: "公告",
        keepAlive: false,
        // hiddenHeader: false,
      },
    },
    {
      name:'expertNotice',
      path: "/expertNotice",
      component: (resolve) => require(["./view/expert/expertNotice.vue"], resolve),
      meta: {
        title: "公告",
        keepAlive: false,
        // hiddenHeader: false,
      },
    },
    // 买家注销
    {
      name:'buyerWriteOff',
      path: "/buyerWriteOff",
      component: (resolve) => require(["./view/buyer/b_writeOff/buyerWriteOff.vue"], resolve),
      meta: {
        title: "申请注销账号",
        keepAlive: false,
        // hiddenHeader: false
      },
    },
    {
      name:'buyerCancellationNotice',
      path: "/buyerCancellationNotice",
      component: (resolve) => require(["./view/buyer/b_writeOff/buyerCancellationNotice.vue"], resolve),
      meta: {
        title: "注销须知",
        keepAlive: false,
        // hiddenHeader: false,
      },
    },
    {
      name:'buyerLogout',
      path: "/buyerLogout",
      component: (resolve) => require(["./view/buyer/b_writeOff/buyerLogout.vue"], resolve),
      meta: {
        title: "安全验证",
        keepAlive: false,
        // hiddenHeader: false,
      },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
